import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class HideOnScroll {
  constructor(element) {
    this.element = element;
    this.tolerance = element.dataset.tolerance;

    this.init();
  }

  init() {
    ScrollTrigger.observe({
      target: window,
      type: 'scroll',
      tolerance: this.tolerance,
      onUp: () => this.element.classList.remove('hide-on-scroll'),
      onDown: () => this.element.classList.add('hide-on-scroll'),
    });
  }
}
